import { useForm } from "antd/es/form/Form";
import { Card, message, Typography } from "antd";
import { useAuth } from "../../../hooks/useAuth";
import { LoginForm } from "../components/LoginForm";
import { logo } from "../../../constants/common";
import { Navigate, Link } from "react-router-dom";

const { Title, Text } = Typography;

export function Login() {
  const [form] = useForm();
  const { data, loading, login } = useAuth();

  const handleSubmit = async (values) => {
    try {
      const data = await login.mutateAsync(values);
      if (!data) {
        message.warning("Không cập nhật được dữ liệu từ hệ thống.");
        return;
      }

      localStorage.setItem("token", data.token);
      message.success("Đăng nhập thành công");

      form.resetFields();
    } catch (error) {
      // Error handled by useAuth
      console.error(error);
      message.error(`${error || "Lỗi hệ thống"}`);
    }
  };

  if (loading) {
    <Typography.Text>Đang tải...</Typography.Text>;
  }

  if (data) {
    return <Navigate to="/bang-dieu-khien" replace />;
  }

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "20px",
      }}
    >
      <Card
        style={{
          width: "100%",
          maxWidth: 500,
          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
          borderRadius: "12px",
        }}
      >
        <div style={{ textAlign: "center", marginBottom: 32 }}>
          <img
            src={logo}
            alt="Chùa Diệu Pháp"
            style={{
              width: 64,
              height: 64,
              marginBottom: 16,
            }}
          />
          <Title
            level={2}
            style={{ margin: 0, color: "#147265", marginBottom: 8 }}
          >
            Đăng nhập
          </Title>

          <Text type="secondary" style={{ fontSize: "14px" }}>
            Chào mừng bạn đến với hệ thống quản lý Chùa Diệu Pháp
          </Text>
        </div>
        <LoginForm
          form={form}
          loading={login.isPending}
          onSubmit={handleSubmit}
        />
        <div style={{ textAlign: "center", marginTop: 16 }}>
          <Link to="/xac-thuc/dat-lai-mat-khau" style={{ color: "#147265" }}>
            Quên mật khẩu?
          </Link>
        </div>
      </Card>
    </div>
  );
}
